import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

import { useForm } from "react-hook-form"
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from "yup"

// Atom 
import Button, { ButtonCategory } from './../../../../Components/Atoms/Button'

// Mol
import Modal, { ModalSize } from './../../../../Components/Molecules/Modal'
import MTooltipModal from "./../../../../Components/Molecules/Modal/Part/MTooltip"

// Sass
import './../../../../Sass/includes/Components/modules/perfilador.sass'

const Perfilador1Counter = (props) =>{
    const {
        min,
        max,
        setContenidoSel,
        contenidoSel,
        descripcion
    } = props
    const [value, setValue] = useState(min)
    

    const increment = () => {
       const val = value + 1 > max ? max : value + 1 
       setValue(val)
        
       contenidoSel.filter(c => c.desc === descripcion)[0].value = val
       setContenidoSel(contenidoSel)
    }
    const decrement = () => {
        const val = value - 1 > min ?  value - 1 : min
        setValue(val)
        contenidoSel.filter(c => c.desc === descripcion)[0].value = val
        setContenidoSel(contenidoSel)
    }
    /*const onChange = (e) => {
        let val = e.target.value;
        
        if(!val || (!isNaN(val) && Number(val) >= min && Number(val) <= max)){
            setValue(val)
            contenidoSel.filter(c => c.desc === descripcion)[0].value = val
            setContenidoSel(contenidoSel)
        }
    }*/

    useEffect(() => {
        
        if(contenidoSel.filter(c => c === descripcion).length === 0){
            const val = {
                desc: descripcion,
                value: min
            }
            contenidoSel.splice(1,0,val)
            setContenidoSel(contenidoSel)  
        }
        
    },[contenidoSel,descripcion,min,setContenidoSel]) // eslint-disable-next-line

    return (
        <div className="customInputNumber">
            <button className="btnMin" type="button" onClick={decrement}>-</button>
            <input type="number" value={value} max={max} min={min} />
            <button className="btnMax" type="button" onClick={increment}>+</button>
        </div>
    )
}

Perfilador1Counter.propTypes = {
    // onClick: PropTypes.func,
    name: PropTypes.string.isRequired,
    min: PropTypes.number,
    max: PropTypes.number
}

Perfilador1Counter.defaultProps = {
    name: 'requerido',
    min: 0,
    max: 10,
}

const Perfilador1Form = React.memo((props) => {
    const {
        onSubmit,
        backButton,
        handleChangeCurrentPage,
        activePage,
        sections,
        nextPage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setPonderacion,
        setContenidoSel,
        contenidoSel
    } = props

    const schemaForm = yup.object().shape({
        structure: yup.string(),

    });

    // eslint-disable-next-line
    const { register, handleSubmit } = useForm({
        defaultValues: {
            size: 1,
            structure: 'fuerte'
        },
        resolver: yupResolver(schemaForm),
    });

    const modalTooltipRef = useRef()
    const openModalTooltip = () => modalTooltipRef.current.open()

    const handleBack = () => {
        console.log('Regresar')
    }

    const section = sections[0]
    
    useEffect(() => {
        console.log("useefect", questionsAnswers)
    },[questionsAnswers])

    const Estructura = contenidoSel.find(c => c.desc === 'Estructura')
    return (
        <form className="formPerfilador" onSubmit={handleSubmit(onSubmit)}>
            <div className="perfiladorStepsWrap">
                <h3>Cuéntanos un poco sobre tu hogar</h3>
                <div className="perfStep1Box">
                    <div className="perfStep1BoxLeft">
                    
                        {
                            questionsAnswers[activePage]?.length
                                ?
                                questionsAnswers[activePage].map((ask, index) => (
                                    <fieldset key={uuid()}>
                                        {
                                            ask.fi_TIPO === 1
                                                ?
                                                <>
                                                    <label>{ask.fc_TITULO}</label>
                                                    {
                                                        ask?.perfiladorRespuestas?.length
                                                            ?

                                                            <span className="select">
                                                                {/* <select defaultValue={""} name={ask.fi_PREGUNTA} onChange={(selected) => handleChangeAnswerSelected(selected)}> */}
                                                                <select name={ask.fi_PREGUNTA} onChange={(selected) => handleChangeAnswerSelected(selected)}>
                                                                    <option value="" disabled>Selecciona una opci&oacute;n</option>
                                                                    {
                                                                        ask.perfiladorRespuestas.map((answ, index) => (
                                                                            <option 
                                                                            value={`${answ.fi_RESPUESTA}|_|${answ.fi_PONDERACION}|_|${ask.fc_DESCRIPCION ? ask.fc_DESCRIPCION : ''}|_|${answ.fc_TITULO}`} key={uuid()}
                                                                            selected={answ?.selected ? answ?.selected : false}
                                                                            >
                                                                            {answ.fc_TITULO}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </span>
                                                            :
                                                            null
                                                    }
                                                </>
                                                : null
                                        }
                                        {
                                            ask.fi_TIPO === 2
                                                ?
                                                <>
                                                    <label>{ask.fc_TITULO}</label>
                                                    {
                                                        ask?.perfiladorRespuestas?.length
                                                            ?

                                                            <div className="perfStep1Options">
                                                                {
                                                                    ask.perfiladorRespuestas.map((answ, index) => (
                                                                        <div className="perfSetp1Radio" key={uuid()}>
                                                                            {/* <input type="radio" name={ask.fi_PREGUNTA} value={answ.fi_RESPUESTA} onChange={(e) => handleChangeAnswerSelected(e)} /> */}
                                                                            <input type="radio" name={ask.fi_PREGUNTA} value={`${answ.fi_RESPUESTA}|_|${answ.fi_PONDERACION}|_|${ask.fc_DESCRIPCION ? ask.fc_DESCRIPCION : ''}|_|${answ.fc_TITULO}`} checked={answ?.selected && answ?.selected === true ? true : false } onChange={(e) => handleChangeAnswerSelected(e)} />
                                                                            <div className="checkmark"></div>
                                                                            <label>
                                                                                <strong>{answ.fc_TITULO}</strong>
                                                                                {answ.fc_DESCRIPCION}
                                                                            </label>
                                                                        </div>
                                                                    ))
                                                                }
                                                            </div>
                                                            :
                                                            null
                                                    }
                                                </>
                                                : null
                                        }
                                        {
                                            ask.fi_TIPO === 3
                                                ?
                                                <>
                                                    <fieldset>
                                                        <label>{ask.fc_TITULO}</label>
                                                        <div className="perfStep1Count">
                                                            <Perfilador1Counter 
                                                                min={ask?.perfiladorRespuestas[0]?.fi_VALOR_MINIMO}
                                                                max={ask?.perfiladorRespuestas[0]?.fi_VALOR_MAXIMO}
                                                                //ponderacion={ask?.perfiladorRespuestas[0]?.fi_PONDERACION}
                                                                setPonderacion={setPonderacion}
                                                                descripcion={ask?.fc_DESCRIPCION}
                                                                setContenidoSel={setContenidoSel}
                                                                contenidoSel={contenidoSel}
                                                            />
                                                        </div>
                                                    
                                                    </fieldset>
                                                </>
                                                : null
                                        }
                                    </fieldset>
                                ))
                                :
                                null
                        }
                        {/* <fieldset>
                            <label>¿Cuántos metros cuadrados tiene tu hogar?</label>
                            <span className="select">
                                <select {...register("size")}>
                                    <option value="1">De 0 a 79 m2</option>
                                    <option value="2">De 80 a 199 m2</option>
                                    <option value="3">De 200 a 299 m2</option>
                                    <option value="4">De 300 a 499 m2</option>
                                    <option value="5">{'>'} 500 m2</option>
                                </select>
                            </span>
                        </fieldset>
                        <fieldset><label>¿Cómo es la estructura interna (paredes) de tu hogar?</label>
                            <div className="perfStep1Options">
                                <div className="perfSetp1Radio">
                                    <input type="radio" name="opt1" value='fuerte' {...register("structure")} />
                                    <div className="checkmark"></div>
                                    <label>
                                        <strong>Fuerte</strong> (Concreto, Blocks)
                                    </label>
                                </div>
                                <div className="perfSetp1Radio">
                                    <input type="radio" name="opt1" value='ligera' {...register("structure")} />
                                    <div className="checkmark"></div>
                                    <label>
                                        <strong>Ligera</strong> (Madera, Paneles de yeso)
                                    </label>
                                </div>
                            </div>
                        </fieldset> */}
                    </div>
                    <div className="perfStep1BoxRight">
                        {
                            section?.fc_IMAGEN !== ""
                                ?
                                <picture>
                                    <source type="image/webp" data-srcset={section?.fc_IMAGEN?.split(".")[0] + ".webp"} srcSet={section?.fc_IMAGEN?.split(".")[0] + ".webp"} />
                                    <source type="image/png" data-srcset={section?.fc_IMAGEN} srcSet={section?.fc_IMAGEN} />
                                    <img className="lazyload" alt={section?.fc_ALT_IMAGEN} width="384" height="404" data-src={section?.fc_IMAGEN} src={section?.fc_IMAGEN} />
                                </picture>
                                : null
                        }
                    </div>
                </div>
            </div>
            <div className="perfiladorBtns perfBtn01">
                {
                    backButton ?
                        <Button
                            category={ButtonCategory.TRANS_GRIS}
                            onClick={() => handleBack()}
                        >
                            Regresar
                        </Button>
                        : null
                }

                {/* <button className='btn btnPrimario' type='submit' value='Perfilador2Org' onClick={(e) => { handleChangeCurrentPage(e, null, nextPage) }}>
                    Continuar
                </button> */}
                {
                    Estructura?.value !== ''
                    ?
                    <button className='btn btnPrimario' type='button' value='Perfilador2Org' onClick={(e) => { handleChangeCurrentPage(e, null, nextPage) }}>
                        Continuar
                    </button>
                    :
                    <button className='btn btnPrimario' type='button' value='Perfilador2Org' onClick={(e) => { openModalTooltip() }}>
                        Continuar
                    </button>
                }
            </div>
            <Modal
                ref={modalTooltipRef}
                size={ModalSize.SMALL}
            >
                <MTooltipModal
                    mensaje={"Seleccione tipo de estructura"}
                    activePage={activePage}
                />
            </Modal>
        </form>
    )
})

Perfilador1Form.propTypes = {
    onSubmit: PropTypes.func,
}

function Perfilador1PeopleOrg(props) {
    const {
        title,
        details,
        backButton,
        handleChangeCurrentPage,
        sections,
        activePage,
        questionsAnswers,
        handleChangeAnswerSelected,
        setPonderacion,
        setContenidoSel,
        contenidoSel
    } = props

    const onSubmitForm = data => {
        console.log('Submit:', data);
    }
    const perfiladorSteps = sections?.length ? sections.map((item, index) => (
        <li key={uuid()} className={index === activePage ? "current" : index <= activePage ? "done" : ""}>
            <span>
                <i>{index + 1}</i>
            </span>
            <strong>{item.fc_TITULO}</strong>
        </li>
    )) : null
    return (
        <section className="light">
            <div className="container">
                <div className="perfiladorTitle">
                    <h2>{title}</h2>
                    <p>{details}</p>
                </div>
                <ul className="perfiladorSteps">
                    {perfiladorSteps}
                    {/* <li className="current">
                        <span>
                            <i>1</i>
                        </span>
                        <strong>Tu Hogar</strong>
                    </li>
                    <li>
                        <span>
                            <i>2</i>
                        </span>
                        <strong>Tus Dispositivos</strong>
                    </li>
                    <li>
                        <span>
                            <i>3</i>
                        </span>
                        <strong>Tus Necesidades</strong>
                    </li> */}
                </ul>
                <Perfilador1Form
                    onSubmit={onSubmitForm}
                    backButton={backButton}
                    handleChangeCurrentPage={handleChangeCurrentPage}
                    sections={sections}
                    activePage={activePage}
                    nextPage={activePage + 1}
                    previousPage={activePage - 1}
                    questionsAnswers={questionsAnswers}
                    handleChangeAnswerSelected={handleChangeAnswerSelected}
                    setPonderacion={setPonderacion}
                    setContenidoSel={setContenidoSel}
                    contenidoSel={contenidoSel}
                />
            </div>
        </section>
    )
}
Perfilador1PeopleOrg.defaultProps = {
    title: "Asesor de Experiencia y Velocidad Wifi",
    details: 'Con nuestro asesor de velocidad de Internet Fijo puedes calcular con mayor exactitud el plan que necesitas en tu hogar.',
}

Perfilador1PeopleOrg.propTypes = {
    title: PropTypes.string,
    details: PropTypes.string,
}

export default Perfilador1PeopleOrg
